import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { changeProps } from "find-and";

import { setLayerOpacity } from "../../ducks/sharedLayers/sharedLayers";
import { useProjectUpdate } from "../../ducks/project/hooks";
import { changeTempSourceLayerOpacity } from "../../ducks/tempSourceLayers/tempSourceLayers";
import { useProjectLayers } from "./useProjectLayers";
import { useIsShared } from "../api/useIsShared";

export function useProjectLayerOpacity(layerName: string, opacity: number) {
  const dispatch = useDispatch();
  const isShared = useIsShared();
  const [value, onChangeValue] = useState<number>(opacity);
  const mutation = useProjectUpdate();
  const layers = useProjectLayers();

  const onStop = useCallback(
    newValue => {
      if (isShared) {
        dispatch(setLayerOpacity({ layerName, opacity: newValue / 100 }));
      } else if (layerName?.startsWith("temp")) {
        dispatch(changeTempSourceLayerOpacity({ layerName, opacity: newValue / 100 }));
      } else {
        mutation({
          content: {
            items: changeProps(layers, { name: layerName }, { opacity: newValue / 100 }),
          },
        });
      }
    },
    [dispatch, layerName, layers, mutation, isShared],
  );

  return {
    opacity: value,
    onChange: onChangeValue,
    onStop,
  };
}
